import { loadStripe } from '@stripe/stripe-js'
import { gql } from 'graphql-request'

export * from '@stripe/react-stripe-js'

export const loadStripeInstance = (key: string) => {
  if (!key) {
    console.warn('Stripe key not provided, Stripe will not be loaded')
    return null
  }

  return loadStripe(key)
}

export const stripeProcessingFeeRate = {
  flat: 0.2,
  percent: 0.014,
}

export const STRIPE_CREATE_PAYMENT = gql`
  mutation StripeCreatePayment($input: StripeCreatePaymentIntentInput!) {
    paymentIntent: stripeCreatePaymentIntent(input: $input) {
      clientSecret
      amount
      currency
    }
  }
`
